import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalConsignmentLinkColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'consignmentId')),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(300)),
        new DateTimeColumn('Completion date', 'completionDate'),
        new TextColumn('Sender', 'sender'),
        new TextColumn('Receiver', 'receiver'),
        new TextColumn('Mail category', 'mailCategory'),
        new TextColumn('Origin country', 'originCountry'),
        new TextColumn('Origin airport', 'originAirport'),
        new TextColumn('Destination country', 'destinationCountry'),
        new TextColumn('Destination airport', 'destinationAirport'),
        new TextColumn('First leg conveyance reference', 'firstLegConveyanceReference'),
        new TextColumn('Last leg conveyance reference', 'lastLegConveyanceReference'),
        new DateTimeColumn('LHOT origin', 'lhotOrigin'),
        new DateTimeColumn('LHOT destination', 'lhotDestination'),
        new TextColumn('Contract reference', 'contractReference'),
        new TextColumn('Booking reference (PAWB)', 'bookingReference'),
      ],
    },
  ];
};
